/** @jsxImportSource @emotion/react */
import type React from 'react';
import { UniversalSpinner } from '../../../components/universal-spinner/universal-spinner';
import {
  ErrorText,
  FullWidth,
  Headline,
  Input,
  InputAndErrorWrapper,
  Label,
  NormalInputWrapper,
  PrimaryButton,
  Screen,
  SpinnerWrap,
  Subhead,
} from './forgot-password.styled';
import { useForgotPassword } from './forgot-password.hooks';
import { VSpace } from '../../chat/settings/account/account-settings';
import type { LoginStepProps } from '../login-shell.types';
import { SkipButton } from '../../registration/pages/secure-your-account/secure-your-account.styled';

export const ForgotPassword: React.FC<LoginStepProps> = ({ go, data, setData }) => {
  const { email, setEmail, loading, error, submit } = useForgotPassword({
    onSuccess: (submittedEmail) => {
      setData({ email: submittedEmail });
      go('verify-reset-code');
    },
    initialEmail: data.email || '',
  });

  const handleGoBack = () => {
    if (loading) return;
    go('email-login');
  };

  return (
    <Screen data-testid="forgot-password-screen">
      <div>
        <VSpace $h={32} />

        <Headline>
          Forgot your <br />
          password?
        </Headline>

        <VSpace $h={32} />

        <Subhead>
          Enter your email to receive <br /> a secure reset code.
        </Subhead>
      </div>

      {/* <VSpace $h={89} /> */}

      <FullWidth>
        {/* <FloatingInput
          id="email"
          type="email"
          label="Enter your email "
          placeholder=""
          value={email}
          onChange={(e: any) => setEmail(e?.target?.value ?? '')}
          disabled={loading}
        /> */}
        <NormalInputWrapper>
          <Label>Account email address</Label>
          <InputAndErrorWrapper>
            <Input
              type="email"
              value={email}
              onChange={(e: any) => setEmail(e?.target?.value ?? '')}
              disabled={loading}
              data-testid="forgot-password-email-input"
            />
            {!loading && error && (
              <ErrorText data-testid="forgot-password-error">{error}</ErrorText>
            )}
          </InputAndErrorWrapper>
        </NormalInputWrapper>

        <VSpace $h={16} />
        <PrimaryButton onClick={submit} disabled={loading} data-testid="forgot-password-submit">
          Send reset code
        </PrimaryButton>

        {loading && (
          <SpinnerWrap data-testid="forgot-password-loading">
            <UniversalSpinner />
          </SpinnerWrap>
        )}

        <VSpace $h={30} />
        <SkipButton
          onClick={handleGoBack}
          data-testid="ob-number-back"
          css={{
            color: '#B7BDCB',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 500,
            fontStyle: 'normal',
            fontSize: '16px',
            lineHeight: '100%',
            letterSpacing: '0px',
            textAlign: 'center',
            verticalAlign: 'middle',
            cursor: 'pointer',
          }}
        >
          Go back
        </SkipButton>
      </FullWidth>
    </Screen>
  );
};
